<template>
  <div @click="menu = true">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          :label="label"
          append-icon='event'
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        @input="menu = false"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    label: String,
    initialDate: String
  },
  data () {
    return {
      currentDate: moment().format('YYYY-MM-DD'),
      date: null,
      dateFormatted: null,
      menu: false
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  created () {
    this.date = this.initialDate || this.currentDate
    this.dateFormatted = this.formatDate(this.date)
  },
  watch: {
    date (value) {
      this.dateFormatted = this.formatDate(this.date)
    },
    dateFormatted (value) {
      this.$emit('change', this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${ day }/${ month }/${ year }`
    }
  }
}
</script>
